import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { customer } from "../characters/Customer";
import { emily } from "../characters/Emily";
import { mc } from "../characters/MC";
import { images } from "./images";
import { V6EmilyCoffeeAfter } from "./V6";
import { doTransition, doWaitImageByTime } from "../helpers/helpers";


export const V6EmilyCoffeeStart = async (): Promise<any> => {

    return jump(V6EmilyCoffee, "V6EmilyCoffee");
};

export const V6EmilyCoffee = async (): Promise<any> => {
    doTransition(images.v6.EmilyCoffee_0);
    emily.talk(`Here we are!`);
    if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {
        emily.talk(`Do you know this place?`);
        mc.talk(`Yes I do.`);
        if (Game.seenScenarios.includes(`V6VanessaAtHome`)) {
            mc.talk(`The girl you saw earlier used to work here.`);
            emily.talk(`Used? Did she quit?`);
            mc.talk(`Got fired... It's a long story.`);
            mc.think(`I think I'll spare her some of the details for now...`);

        } else {
            mc.talk(`Joey's girlfriend, Vanessa, used to work here.`);
            emily.talk(`Used? Did she quit?`);
            mc.talk(`Got fired... It's a long story.`);
            mc.think(`I think I'll spare her some of the details for now...`);

        }
        emily.talk(`I'm ready to order but I don't see the barista anywhere...`);
    } else {
        emily.talk(`I don't see the barista anywhere... I hope we can get service.`);
    }

    mc.talk(`Maybe she's on her break, let's just take a seat inside and wait.`);
    emily.talk(`Alright!`);
    return jump(V6EmilyCoffeeSitting, "V6EmilyCoffeeSitting");

};

export const V6EmilyCoffeeSitting = async (): Promise<any> => {
    doWaitImageByTime(images.v6.EmilyCoffee_2);

    emily.talk(`I hope she gets here soon I'm dying for that coffee!`);

    if (Game.seenScenarios.includes(`VanessaCoffee1`)) {
        mc.think(`Oh shit, the guy in the back is the guy that got Vanessa fired.`);
        mc.think(`I promised Vanessa that I'd help her get her job back...`);
        mc.think(`Now is the perfect opportunity.`);
        emily.talk(`So I wanted to ask you a question.`);
        mc.talk(`Just a second Emily.`);
        ImageClass.setImage(images.v6.EmilyCoffee_9_2);
        emily.talk(`Why, is there something wrong?`);
        mc.talk(`No, I need to have a word with that dude in the back.`);
        ImageClass.setImage(images.v6.EmilyCoffee_4);
        emily.talk(`Ah?`);
        emily.talk(`About what?`);
        mc.talk(`I'll tell you once I get back. Give me a second.`);
        return jump(V6EmilyCoffeeCustomer, "V6EmilyCoffeeCustomer");
    }
    return jump(V6EmilyCoffeeContinue, "V6EmilyCoffeeContinue");
};

export const V6EmilyCoffeeCustomer = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyCoffee_5);
    mc.talk(`Excuse me.`);
    ImageClass.setImage(images.v6.EmilyCoffee_6);
    customer.talk(`Huh? What?`);
    customer.talk(`What do you need?`);
    customer.talk(`Wait! I remember you.`);
    if (mc.properties.v3RudeToTheCustomer === false) {

        customer.talk(`You are a friend of that barista that got fired.`);
    } else {
        if (Question.globalAnswers.v3VanessaCoffeeToldCustomerFuckOff) {

            customer.talk(`You are that little squirt that told me to fuck off.`);
        } else if (Question.globalAnswers.v3VanessaCoffeeCustomerApologized === false) {

            customer.talk(`You are that little squirt that told me to get lost.`);
        }

    }

    mc.think(`He has a good memory for someone his age.`);

    customer.talk(`What do you want?`);
    mc.talk(`To get my friend's job back.`);
    customer.talk(`Is that so?`);
    ImageClass.setImage(images.v6.EmilyCoffee_5);
    customer.talk(`It's only a coffee shop, I'm sure she can find a better job somewhere else.`);
    mc.talk(`She insists on having this job.`);

    mc.talk(`Come on. What do you want? An apology?`);

    ImageClass.setImage(images.v6.EmilyCoffee_6);
    customer.talk(`An apology won't cut it.`);
    customer.talk(`But no worries. I am a reasonable man.`);
    mc.talk(`Are you serious? It's just a barista job.`);
    customer.talk(`That's what I said. She can get another job if she doesn't agree to my terms.`);
    mc.talk(`What are your terms?`);
    customer.talk(`I'd rather say it in person. To her.`);
    mc.talk(`I'm already here, just say it to me.`);

    customer.talk(`There is no discussion here. Tell her that I'm willing to get her job back, but she needs to meet me in person.`);
    mc.talk(`What are you planning, are you gonna kidnap her or something?`);
    customer.talk(`You can be there as well. I don't mind, you are a part of it after all.`);

    ImageClass.setImage(images.v6.EmilyCoffee_8);
    customer.talk(`By the way. Who is the girl you came in with?`);

    if (mc.properties.alpha > 7) {
        mc.talk(`I don't know what your creepy mind is thinking of but she's my ${emily.properties.relation} and she has nothing to do with it.`);

    } else {
        mc.talk(`That's my ${emily.properties.relation} and she has nothing to do with it.`);

    }

    ImageClass.setImage(images.v6.EmilyCoffee_7);
    customer.talk(`I was just asking. No need to get upset.`);

    customer.talk(`Anyway, I'm going to give you my number. Tell your friend that these are my terms.\nShe can take it or find another job.`);

    mc.talk(`Where do you wanna meet?`);
    customer.talk(`I move around. Just contact me and we'll find a good spot to talk.`);
    mc.talk(`Alright.`);

    mc.think(`Time to get back to Emily.`);

    return jump(V6EmilyCoffeeCustomerAfter, "V6EmilyCoffeeCustomerAfter");
};

export const V6EmilyCoffeeCustomerAfter = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyCoffee_9);
    await mc.set((properties) => {
        global.toast?.show(`You now have the customer's number`);
    });
    emily.talk(`What was that about? How do you know that guy?`);
    mc.talk(`He is a regular here... And... Got Vanessa fired so she asked me if I can talk to him to get her job back.`);
    emily.talk(`So that's why she got fired.`);
    emily.talk(`But how are you involved?`);
    mc.talk(`I came to visit Vanessa while she was working here, and that guy came in and wanted to order something...`);
    if (mc.properties.v3RudeToTheCustomer) {
        mc.talk(`And I wasn't exactly nice to him.`);
        ImageClass.setImage(images.v6.EmilyCoffee_3);
        emily.talk(`You? But you are the nicest person I know! What did you say to him?`);
        ImageClass.setImage(images.v6.EmilyCoffee_9_2);
        mc.talk(`That's not important.`);
    } else {
        mc.talk(`And she wasn't exactly nice to him.`);
        ImageClass.setImage(images.v6.EmilyCoffee_9_2);
        emily.talk(`What did she say?`);
        mc.talk(`She kinda told him to fuck off because she was talking to me.`);


        emily.talk(`Oh, that's a way to serve your customers.`);
        mc.talk(`Yeah... So apparently he has some connection so he got Vanessa fired.`);
        emily.talk(`Well, she kinda got what she deserved.`);
    }

    emily.talk(`I still don't get why you need to be the one who talks to him.`);
    mc.talk(`I don't have to. She asked me for a favor.`);
    emily.talk(`Ok, makes sense.`);

    return jump(V6EmilyCoffeeContinue, "V6EmilyCoffeeContinue");
};


export const V6EmilyCoffeeContinue = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V6EmilyCoffeeCustomerAfter`)) {
        ImageClass.setImage(images.v6.EmilyCoffee_9_2);
        mc.talk(`Let's just forget about him.\nWhat did you want to ask me?`);
        ImageClass.setImage(images.v6.EmilyCoffee_2);
        emily.talk(`Oh yeah! About that.`);
    } else {
        ImageClass.setImage(images.v6.EmilyCoffee_2);
        emily.talk(`So I wanted to ask you a question.`);
    }
    if (Game.seenScenarios.includes(`V6VanessaAtHome`)) {
        ImageClass.setImage(images.v6.EmilyCoffee_3);
        emily.talk(`I know she is Joey's girlfriend, but do you think that Vanessa might be... A lesbian?`);

        ImageClass.setImage(images.v6.EmilyCoffee_9_2);
        mc.talk(`Haha, no.`);
        mc.talk(`Why do you ask? Because of the way she was talking to you at the house?`);
        ImageClass.setImage(images.v6.EmilyCoffee_9_2);
        emily.talk(`Yeah...`);
        mc.talk(`That's just how she is... She is very... playful.`);
        emily.talk(`Oh... Does she do that around Joe as well?`);
        mc.talk(`I believe she might... No one can stop that girl.`);
        ImageClass.setImage(images.v6.EmilyCoffee_3);
        emily.talk(`Oh, wow... I'm surprised he chose a girl like that as his girlfriend.`);
        ImageClass.setImage(images.v6.EmilyCoffee_9_2);
        emily.talk(`I mean, I'm sure she is great and nice and all of that. But it's hard for me to imagine them together.`);

        ImageClass.setImage(images.v6.EmilyCoffee_2);
        emily.talk(`But enough about her!`);
    } else {
        emily.talk(`I'm glad I met Ann! She seems like a great girl!`);
        emily.talk(`From the first impression I know why you like her.`);
        ImageClass.setImage(images.v6.EmilyCoffee_9_2);
        emily.talk(`But I had a feeling she was scared of me.`);
        mc.talk(`She was a bit surprised to see a girl in the house she hadn't heard of...`);
        mc.talk(`And the way you came out of your room didn't add to it.`);
        ImageClass.setImage(images.v6.EmilyCoffee_3);
        emily.talk(`Yeah... You might be right.`);
        ImageClass.setImage(images.v6.EmilyCoffee_9_2);
        emily.talk(`I guess I fucked up.`);
        mc.talk(`Nah. Don't worry about it.`);
        mc.talk(`Once she gets to know you she will love you.`);
        ImageClass.setImage(images.v6.EmilyCoffee_2);
        emily.talk(`I hope so.`);
        emily.talk(`Anyway!`);
    }

    ImageClass.setImage(images.v6.EmilyCoffee_9_2);
    emily.talk(`Did you notice that couple at the shopping store?`);
    mc.talk(`The shouting couple? Sure, I noticed.`);
    ImageClass.setImage(images.v6.EmilyCoffee_3);
    emily.talk(`So... The guy kept staring at me...`);
    if (mc.properties.v3RudeToTheCustomer) {
        ImageClass.setImage(images.v6.EmilyCoffee_9_2);
        emily.talk(`It's the same look as that old dude in the back just gave me...`);
    } else {

    }
    ImageClass.setImage(images.v6.EmilyCoffee_9_2);
    emily.talk(`I'm used to guys looking at me... But they usually don't dare do that around their partner.`);
    emily.talk(`But that guy didn't care at all...`);
    emily.talk(`So creepy.`);
    if (Game.seenScenarios.includes(`V6AfterEmilyShoppingTryingLingerieMario_Question_LetHim`)) {
        mc.think(`I wonder if she means before or after I let him open her booth's door...`);

    }

    mc.talk(`Yeah... Some guys are like that. There is really nothing you can do about that.`);
    ImageClass.setImage(images.v6.EmilyCoffee_3);
    emily.talk(`I forgot how many creepy guys there are in this town...`);
    ImageClass.setImage(images.v6.EmilyCoffee_9_2);
    mc.talk(`There are a lot of creepy guys to go around anywhere.`);

    emily.talk(`Yeah, I guess... I must have just forgotten what it's like, because the town I just moved from was flooded with girls, so the creepiness was shared between them.`);
    mc.talk(`Tons of girls?! Maybe I should have came with you!`);
    ImageClass.setImage(images.v6.EmilyCoffee_2);
    emily.talk(`Haha, maybe.`);

    return jump(V6EmilyCoffeeContinue_2, "V6EmilyCoffeeContinue_2");
};

export const V6EmilyCoffeeContinue_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyCoffee_9_2);
    emily.talk(`I don't think we're gonna get service today.`);
    mc.talk(`Yeah...`);
    ImageClass.setImage(images.v6.EmilyCoffee_2);
    emily.talk(`Thanks for joining me ${mc.name}!`);
    mc.talk(`It wasn't that bad. I had a great time.`);
    emily.talk(`I'm glad to hear that!`);

    emily.talk(`Ok... Time to leave, I'll just get my coffee at home.`);
    if (Game.seenScenarios.includes(`V6AnnArrived`)) {
        mc.think(`Ann told me she is at the library, I guess I'll go and visit her there.`);
        mc.talk(`Sounds good. I'm going to stop by the library and say hey to Ann, cool?`);
        emily.talk(`Haha, missing her already? You've just seen her!`);
        mc.talk(`It's just a friendly visit.`);
        emily.talk(`Haha, sure! Enjoy.`);
        mc.talk(`I'll meet you back at home later.`);
        return jump(V6EmilyCoffeeAfter, "V6EmilyCoffeeAfter");
    }

    return jump(V6EmilyCoffeeAfter, "V6EmilyCoffeeAfter");
};